/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Login_In_ProgressInputs */

const en_home_login_in_progress = /** @type {(inputs: Home_Login_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in`)
};

const fr_home_login_in_progress = /** @type {(inputs: Home_Login_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion en cours`)
};

const ms_sg2_home_login_in_progress = /** @type {(inputs: Home_Login_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang log masuk`)
};

/**
* | output |
* | --- |
* | "Signing in" |
*
* @param {Home_Login_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const home_login_in_progress = /** @type {((inputs?: Home_Login_In_ProgressInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Login_In_ProgressInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_login_in_progress(inputs)
	if (locale === "fr") return fr_home_login_in_progress(inputs)
	return ms_sg2_home_login_in_progress(inputs)
});